import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { useAdminAuth } from "../AuthContext";
import { api, formatApiErrorDetail } from "../api";

const ChangePassword = () => {
  const { user, refresh } = useAdminAuth();
  const navigate = useNavigate();
  const forced = user?.must_change_password;
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 12) return setError("Ny adgangskode skal være mindst 12 tegn.");
    if (next !== confirm) return setError("De to nye adgangskoder er ikke ens.");
    setBusy(true);
    try {
      await api.changePassword(current, next);
      await refresh();
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.detail) || "Kunne ikke skifte adgangskode.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1A2E24] flex items-center justify-center px-5" data-testid="admin-changepw-page">
      <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-xl w-full max-w-md" data-testid="admin-changepw-form">
        <span className="inline-flex items-center justify-center h-11 w-11 rounded-full bg-[#2D5A3F]/10 text-[#2D5A3F] mb-4">
          <ShieldCheck className="h-6 w-6" strokeWidth={1.5} />
        </span>
        <h1 className="font-display text-2xl text-[#1A2E24] mb-1">Skift adgangskode</h1>
        <p className="text-sm text-[#5C7567] mb-6">
          {forced
            ? "Af sikkerhedshensyn skal du vælge en ny adgangskode ved første login."
            : "Vælg en ny, stærk adgangskode (mindst 12 tegn)."}
        </p>

        {["Nuværende adgangskode", "Ny adgangskode", "Gentag ny adgangskode"].map((label, i) => (
          <div key={label}>
            <label className="block text-xs uppercase tracking-wide text-[#5C7567] mb-1.5">{label}</label>
            <input
              type="password"
              required
              value={i === 0 ? current : i === 1 ? next : confirm}
              onChange={(e) => (i === 0 ? setCurrent : i === 1 ? setNext : setConfirm)(e.target.value)}
              data-testid={`admin-changepw-${i === 0 ? "current" : i === 1 ? "new" : "confirm"}`}
              className="w-full mb-4 rounded-xl border border-black/10 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#2D5A3F]/40"
            />
          </div>
        ))}

        {error && <p className="text-sm text-red-600 mb-4" data-testid="admin-changepw-error">{error}</p>}

        <button
          type="submit"
          disabled={busy}
          data-testid="admin-changepw-submit"
          className="w-full flex items-center justify-center gap-2 rounded-full bg-[#2D5A3F] text-white py-3 font-medium hover:bg-[#244b34] transition-colors duration-200 disabled:opacity-60"
        >
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Gem ny adgangskode
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
